module.exports = __webpack_public_path__ + "img/flowers-card-640.72a5a3a1.jpg";